const isPhoneNumber = /^\s*\+?\s*([0-9][\s-]*){9,}$/;

export default isPhoneNumber;
